require('./accountDebitReturn.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const DateHelper = require('utilities/dateHelper');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ actions
const accountDebitsActions = require('actions/accountDebits');
const printerActions = require('actions/contactCenter/printer');
// @components
import OKLayout from 'components/commons/OKLayout/OKLayout';
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { formatAmountObject } = require('utilities/currencyHelper');
const AccountDebitReturnSuccess = require('components/accounts/accountDebits/accountDebitReturnSuccess/accountDebitReturnSuccess');
const AccountDebitReturnFailure = require('components/accounts/accountDebits/accountDebitReturnFailure/accountDebitReturnFailure');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
// @ constants
const { DEBIT_RETURN } = require('constants/operationTypes');
const { API_ENTERPRISE_NUMBER, API_CENTER, GRAPHIC_TUTOR_TYPE_3, DATE_FORMAT_EXTENDED } = require('constants/index');
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
import { NEGATIVE } from 'constants/layout';
//@utilities
const AccessHelper = require('utilities/accessHelper');
const receiptNumberHelper = require('utilities/receiptNumberHelper');
// @ conctact-center
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');

class AccountDebitReturn extends React.Component {
    constructor(props) {
        super(props);
        this.buildPreLeaveModal = this.buildPreLeaveModal.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDebitReturn = this.handleDebitReturn.bind(this);
        this.handleProcessCancel = this.handleProcessCancel.bind(this);
        this.isReady = this.isReady.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { history, immAccounts, match: { params: { accountId } }, debitReturnWillCancel } = this.props;

        AccessHelper.allowAccess(accountConstants.ACCOUNTS_DEBIT_RETURN, {
            immAccounts,
            accountId
        }, history);

        debitReturnWillCancel();
    }

    componentWillUnmount() {
        const { resetPrintedIndicators } = this.props
        resetPrintedIndicators()
    }

    buildReceiptFailure(errorMessage) {
        const { match: { params: { accountId } } } = this.props;
        return <AccountDebitReturnFailure accountId={accountId} errorMessage={errorMessage} />;
    }

    buildReceiptSuccess() {
        const { match: { params: { accountId, receiptNumber } }, immReceipts } = this.props;
        const receipt = immReceipts.getIn([accountId, 'byId', receiptNumber]);
        const receiptDate = receipt.get('date');
        const receiptAmount = receipt.get('amount');
        const issuingCompanyName = receipt.get('nombre');

        return (
            <AccountDebitReturnSuccess
                accountId={accountId}
                issuingCompanyName={issuingCompanyName}
                receiptNumber={receiptNumberHelper(receiptNumber)}
                receiptDate={receiptDate}
                receiptAmount={receiptAmount}
            />
        );
    }

    buildPreLeaveModal() {
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        return (
            <PreLeaveModalComponent
                confirmationMessage={confirmationMessage}
                confirmationTitle={confirmationTitle}
                acceptText={acceptText}
                cancelText={cancelText}
                isReady={this.isReady}
                onConfirmLeave={this.handleProcessCancel}
            />
        );
    }

    handleProcessCancel() {
        const { debitReturnWillCancel } = this.props;
        debitReturnWillCancel();
    }

    isReady() {
        return false;
    }

    buildReceipt() {
        const { match: { params: { accountId, receiptNumber } }, immAccounts } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);

        const alias = immAccount.get('alias');
        const ibanFormatted = getLastNChars(immAccount.get('iban'));
        const accountInCharge = alias + ibanFormatted;
        const receipt = this.props.immReceipts.getIn([accountId, 'byId', receiptNumber]);
        const name = receipt.get('nombre');
        const reference = receipt.get('refmand');
        const receiptDate = receipt.get('fecvenci');
        const amount = receipt.get('amount');
        const receiptAmount =
            formatAmountObject(amount).amount +
            ' ' +
            formatAmountObject(amount).currencySymbol;
        const originAccount = API_ENTERPRISE_NUMBER.concat(
            API_CENTER,
            immAccount.get('newProduct'),
            immAccount.get('newContractNumber')
        );
        const operationParams = {
            originAccount
        };

        const operative = formatText('operatives-returnReceipt');

        return (
            <div id="printable-wizard">
                <div className="account-debits-return__title">
                    <FormattedText value="accountDebitReturn-title" />
                </div>
                <ContactCenterRender>
                    <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                </ContactCenterRender>
                <div className="account-debits-return__text">
                    <FormattedText value="accountDebitReturn-text" />
                </div>
                <div className="account-debits-return__header-container">
                    <OKInformativeList columns={3}>
                        <OKInformativeListItem
                            title={formatText('accountDebitReturn-issuingCompanyName')}
                            bodyText={name}
                        />
                        <OKInformativeListItem
                            title={formatText('accountDebitReturn-receiptDate')}
                            bodyText={DateHelper.formatDate(receiptDate, DATE_FORMAT_EXTENDED).toLowerCase()}
                        />
                        <OKInformativeListItem
                            title={formatText('accountDebitReturn-ibanFormatted')}
                            bodyText={accountInCharge}
                        />
                        <OKInformativeListItem
                            title={formatText('accountDebitReturn-reference')}
                            bodyText={reference}
                        />
                        <OKInformativeListItem
                            title={formatText('accountDebitReturn-receiptNumber')}
                            bodyText={receiptNumberHelper(receiptNumber)}
                        />
                        <OKInformativeListItem
                            title={formatText('accountDebitReturn-receiptAmount')}
                            bodyText={receiptAmount}
                        />
                    </OKInformativeList>
                </div>
                <div className="account-debits-return__signature-container">
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    <SignaturePattern
                        operationType={DEBIT_RETURN}
                        operationParams={operationParams}
                    />
                </div>
                <div className="row account-debits-return__actions-container">
                    <div className="col-xs-6">
                        <OKButton
                            modifier="link-ghost"
                            size="regular"
                            onClick={this.handleCancel}
                        >
                            <FormattedText value="accountDebitReturn-cancel" />
                        </OKButton>
                    </div>
                    <div className="col-xs-6 text-right">
                        <OKButton modifier="primary" size="regular" onClick={this.handleDebitReturn}>
                            <FormattedText value="accountDebitReturn-return" />
                        </OKButton>
                    </div>
                </div>
                {this.buildPreLeaveModal()}
            </div>
        );
    }

    handleCancel() {
        this.props.history.goBack();
    }

    handleDebitReturn() {
        const { match: { params: { accountId, receiptNumber } }, immReceipts } = this.props;
        const receiptToReturn = immReceipts.getIn([accountId, 'byId', receiptNumber]);
        this.props.debitReturn(receiptToReturn);
    }

    render() {
        let mappingBreadcrumb = [];

        const { match: { params: { accountId } }, immAccounts, immDebitReturn } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const submitSuccessful = immDebitReturn.get('submitSuccessful');
        const errorReceived = immDebitReturn.get('errorReceived');
        const errorMessage = immDebitReturn.getIn(['errorReceived', 'description']);
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_3}
                title={formatText('tutorials-returnReceiptTitle')}
            />
        );
        let content;

        if (!(immAccount && immAccount.size)) {
            content = <section className="account-debits-return" />;
        } else {
            let contentView;

            if (submitSuccessful) {
                contentView = this.buildReceiptSuccess();
            } else {
                if (!!errorReceived) {
                    contentView = this.buildReceiptFailure(errorMessage);
                } else {
                    contentView = this.buildReceipt();
                }
            }

            mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-accounts'),
                    url: '/myprofile/accounts'
                },
                {
                    text: formatText('breadcrumb-debits'),
                    url: `/myprofile/accounts/${accountId}/debits`
                },
                {
                    text: formatText('breadcrumb-debitReturn'),
                    url: ''
                }
            ];

            content = (
                <OKLayout
                    breadcrumb={mappingBreadcrumb}
                    className="account-debits-return"
                    title={getFinalTitle('landingHeader-return')}
                    section="accounts"
                    contentPosition={NEGATIVE}
                    tutorial={tutorial}
                >
                    <OKSectionBox>
                        <div className="row">
                            <div className="col-xs-12">
                                {contentView}
                            </div>
                        </div>
                    </OKSectionBox>
                </OKLayout>
            );
        }
        return content;
    }
}
AccountDebitReturn.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immReceipts: PropTypes.object,
    resetPrintedIndicators: PropTypes.func.isRequired,
    immDebitReturn: PropTypes.object,
    debitReturn: PropTypes.func.isRequired,
    debitReturnWillCancel: PropTypes.func.isRequired
};
module.exports.constructor = AccountDebitReturn;
module.exports.AccountDebitReturn = connect(
    state => ({
        immAccounts: state.accounts,
        immReceipts: state.receipts,
        immDebitReturn: state.debitReturn
    }),
    {
        debitReturn: accountDebitsActions.debitReturn,
        resetPrintedIndicators: printerActions.resetPrintedIndicators,
        debitReturnWillCancel: accountDebitsActions.debitReturnWillCancel
    }
)(withRouter(AccountDebitReturn));
